<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        غذا
      </h4>
    </b-card-header>
    <b-card-body>
      <validation-observer
        #default="handleSubmit"
        ref="refFormObserver"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col md="4">
              <validation-provider
                #default="validationContext"
                name="نام غذا"
                rules="required"
              >
                <b-form-group>
                  <label for="name">
                    <feather-icon
                      icon="FeatherIcon"
                    />
                    نام غذا
                  </label>
                  <b-form-input
                    id="name"
                    v-model="name"
                    placeholder="نام غذا را وارد نمایید"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="isActive" />
                <b-form-checkbox
                  id="isActive"
                  v-model="isActive"
                  checked="true"
                  name="check-button"
                  class="custom-control-success"
                  switch
                >
                  فعال
                </b-form-checkbox>
              </b-form-group>
            </b-col>

          </b-row>
        </b-form>
      </validation-observer>
      <button
        class="btn btn-info mt-2"
        @click="createFood"
      >
        ذخیره غذا
      </button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormInvalidFeedback, BFormCheckbox,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'FoodCreate',
  components: {
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      name: '',
      isActive: true,
    }
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
  methods: {
    createFood() {
      this.$refs.refFormObserver.validate()
        .then(success => {
          if (success) {
            this.$http.post('foods', {
              name: this.name,
              is_active: this.isActive,
            })
              .then(({ data }) => {
                if (data.status) {
                  this.$bvToast.toast('غذا با موفقیت ایجاد شد', {
                    title: 'موفقیت',
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                  })
                  this.name = ''
                  this.isActive = true
                } else {
                  this.$bvToast.toast(data.message ?? 'در غذا خطایی رخ داده', {
                    title: 'حطا',
                    toaster: 'b-toaster-top-right',
                    variant: 'danger',
                  })
                }
              })
              .catch(error => {
                this.$bvToast.toast(error.response.data.message ?? error.message, {
                  title: 'خطا در دریافت اطلاعات',
                  toaster: 'b-toaster-top-right',
                  variant: 'danger',
                })
              })
          }
        })
    },
  },
  setup() {
    const {
      getValidationState,

    } = formValidation(name)

    return {
      getValidationState,
    }
  },
}
</script>

<style>

</style>
